import { render, staticRenderFns } from "./InstructorDetails.vue?vue&type=template&id=bf70d8e8&scoped=true&"
import script from "./InstructorDetails.vue?vue&type=script&lang=ts&"
export * from "./InstructorDetails.vue?vue&type=script&lang=ts&"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&lang=css&"
import style1 from "./InstructorDetails.vue?vue&type=style&index=1&id=bf70d8e8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf70d8e8",
  null
  
)

export default component.exports